module.exports = __webpack_public_path__ + "img/register_preview.20339332.png";